import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import Footer from './Navigation/Footer';
import AppHeader from './Navigation/AppHeader';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = (props) => {
  const { children } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      <AppHeader />
      <Box sx={{ width: '100%' }}>{children}</Box>
      <Footer />
    </Box>
  );
};
